<template>
  <main>
      <transition-group name="fadeimg" mode="in-out">
            <router-link 
                :to="{ name: 'project', params: { id: project.uid }}"
                v-for="(project, index) in home.projects" 
                :key="project.uid" 
                class="absolute top-0 left-0 w-full h-screen transition duration-1000 ease-in-out" 
                v-show="sIndex == index"
            >
                <img class="w-full h-full object-cover" v-lazy="project.image.thumb" :data-srcset="project.image.srcset" :alt="project.title" /> 
            </router-link>
      </transition-group>
      <logo />
  </main>
</template>

<script>
import { mapState } from "vuex";
import Logo from "@/components/Logo.vue";
export default {
    name: "home",
    components: {
        Logo,
    },
    data() {
        return {
            sIndex: 0,
        }
    },
    mounted() {
        setInterval(() => {
            this.next();
        }, 2000)  
    },
    computed: mapState(["home"]),
    methods: {
        next() {
            if(this.sIndex == this.home.projects.length - 1) {
                this.sIndex = 0
            } else {
                this.sIndex++;
            }
        }
    }
};
</script>
